module.exports = __webpack_public_path__ + "img/icon_other.d6db4cbf.png";